import axios from '@axios'

export default {
  namespaced: true,
  state: {
    items: [],
    logs: [],
  },
  getters: {
    getItems(state) {
      return state.items
    },
    getSelectedItems(state) {
      return state.items.map(action_plan => ({
        value: action_plan.id,
        label: action_plan.name,
      }))
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value
    },
    setLogsData(state, value) {
      state.logs = value
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get('v1/action_plan', { params })

      if (!data.success) {
        return []
      }

      commit('setData', data.data)
      return data
    },
    async show(_, id) {
      const { data } = await axios.get(`v1/action_plan/${id}`);

      return data;
    },
    async add(_, params) {
      const { data } = await axios.post('v1/action_plan', params)

      return data
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/action_plan/${id}`, params)

      return data
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/action_plan/${id}`)

      return data
    },
    async getLogs({ commit }, params) {
      const { data } = await axios.get('v1/action_plan/get-action-plan-logs', { params })

      if (!data) {
        return []
      }

      commit('setLogsData', data.data)
      return data
    },
    async getUsers(_, idTenant) {
      const { data } = await axios.get(`v1/action_plan/get-users-by-tenant/${idTenant}`)

      return data
    },
    async setUsers(_, params) {
      const { data } = await axios.post(`v1/action_plan/users`, params)

      return data
    },
    async actionPlansUser(_) {
      const { data } = await axios.get('v1/action_plan/by-user');

      return data
    },
    async actionPlansCompleted(_, id) {
      const { data } = await axios.get(`v1/action_plan/check-by-user-assignment/${id}`);

      return data
    },
    async actionPlanValidate(_, uuid) {
      const { data } = await axios.get(`v1/action_plan/logs/${uuid}/validate`);

      return data
    },
    clear({ commit }) {
      commit('setData', [])
    }
  },
}
